import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, ViewChildren } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as Chart from 'chart.js';
import { ActivatedRoute, Route, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { IssueService } from '../../../../services/issue.service';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issues-high-balance-chart',
    template: '<canvas id="basechart" #basechart *ngIf="data.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [':host { width: 100%; position: relative; display:block; }']
})
export class IssuesHighBalanceChart implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    data: any[] = [];
    labels: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;
    siteId: number;

    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router) {

    }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');

        this.issueService.issuePaygHighBalance(this.clientId, this.siteId).then((highBalanceRes) => {
            let result = highBalanceRes as any;
            if (result.consumerWithHighBalanceBelow200 > 0 || result.consumersWithHighBalanceOver200500 > 0 || result.consumersWithHighBalanceOver5001000 > 0
                || result.consumersWithHighBalanceOver1000 > 0) {
                this.data = [];
                this.labels = [];
                if (result.consumerWithHighBalanceBelow200 > 0) {
                    this.data.push(highBalanceRes.consumerWithHighBalanceBelow200);
                    this.labels.push('Credit Status <= £200');
                }

                if (result.consumersWithHighBalanceOver200500 > 0) {
                    this.data.push(highBalanceRes.consumersWithHighBalanceOver200500);
                    this.labels.push('Credit Status > £200 <= £500');
                }

                if (result.consumersWithHighBalanceOver5001000 > 0) {
                    this.data.push(highBalanceRes.consumersWithHighBalanceOver5001000);
                    this.labels.push('Credit Status > £500 <= £1000');
                }

                if (result.consumersWithHighBalanceOver1000 > 0) {
                    this.data.push(highBalanceRes.consumersWithHighBalanceOver1000);
                    this.labels.push('Credit Status > £1000');
                }


            }
            this.createChart();
        });
        
        this.createChart();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    private getChartConfig(): any {
        let config = {
            type: 'doughnut',
            options: {
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                maintainAspectRatio: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                        scaleLabel: {
                            display: true,
                            labelString: 'Amount Days',
                            fontSize: 15,
                        },
                    }],
                    yAxes: [
                        {
                            display: false,
                            scaleLabel: {
                                display: true,
                                labelString: 'Amount',
                                fontSize: 15,
                                fontStyle: "bold",
                            },
                        },
                    ]

                }
            }
        }

        return config;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        datasets.push({
            label: 'Emergency', 
            data: this.data, 
            backgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointRadius: 3,
            borderWidth: 2,
            pointHoverRadius: 8,
            pointHitRadius: 10,
            borderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointBorderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointBackgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointHoverBackgroundColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
            pointHoverBorderColor: ['#93c01f', '#F9E533', '#FFC000', '#c82b2b'],
        });

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: { datasets: datasets, labels: this.labels }
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            if (!this.basechart.first) return;
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }
}
